<template>
  <div class="common-box contractManagement">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="合同编号：">
              <el-input
                size="mini"
                v-model.trim="form.contractNumber"
                placeholder="请输入合同编号"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目名称：">
              <el-select
                size="mini"
                v-model="form.projectId"
                filterable
                placeholder="请选择项目名称"
                clearable
                reserve-keyword
                :remote="true"
                :remote-method="searchProjectList"
                @visible-change="searchProjectList('')"
                value-key="id"
                @change="handleSearchListData"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.projectName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="甲方名称：">
              <el-input
                size="mini"
                v-model.trim="form.propertyUnitName"
                placeholder="请输入甲方名称"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同类型：">
              <el-select
                size="mini"
                v-model="form.contractTypeCode"
                value-key="dictionaryCode"
                placeholder="请选择合同类型"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in htlxDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同来源：">
              <el-select
                size="mini"
                v-model="form.contractSourceCode"
                value-key="dictionaryCode"
                placeholder="请选择合同来源"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in htlyDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签约人：">
              <el-input
                size="mini"
                v-model.trim="form.contractor"
                placeholder="请输入签约人"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同状态：">
              <el-select
                size="mini"
                v-model="form.contractStatus"
                value-key="dictionaryCode"
                placeholder="请选择合同状态"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in contractStatusList"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算状态：">
              <el-select
                size="mini"
                v-model="form.accountingStatus"
                value-key="dictionaryCode"
                placeholder="请选择结算状态"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in accountingStatusList"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否驻场：">
              <el-select
                size="mini"
                v-model="form.residentCode"
                value-key="dictionaryCode"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in sfzcDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                  placeholder="是否驻场"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="付款周期：">
              <el-select
                size="mini"
                v-model="form.paymentPeriod"
                value-key="dictionaryCode"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in paymentPeriodList"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                  placeholder="请选择付款周期"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式：">
              <el-select
                size="mini"
                v-model="form.paymentModeCode"
                value-key="dictionaryCode"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in zffsDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item"
                  placeholder="请选择支付方式"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务方式：">
              <el-select
                size="mini"
                v-model="form.serviceModeCode"
                value-key="dictionaryCode"
                @change="handleSearchListData"
                clearable
              >
                <el-option
                  v-for="item in fwfsDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item"
                  placeholder="请选择服务方式"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="乙方名称：">
              <el-input
                size="mini"
                v-model.trim="form.secondParty"
                placeholder="请输入乙方名称"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="服务时间：">
              <el-date-picker
                v-model="timeObj"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                @change="chooseTime"
              ></el-date-picker>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['HTTJ']"
          class="plr28"
          @click="jumpAdd"
          >添加</el-button
        >
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['HTSC']"
          @click="deleteContractMore"
          class="plr28"
          plain
          >删除</el-button
        >
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['HTDR']"
          @click="handleInput"
          class="plr28"
          plain
          >导入</el-button
        >
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['HTDC']"
          @click="exportContract"
          class="plr28"
          plain
          >导出</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="importRecords"
          plain
          v-if="hasRole['HTDRJL']"
          >导入记录</el-button
        >
        <el-radio-group v-model="form.contractCode" @change="handleSearchListData">
          <el-radio :label="0">默认</el-radio>
          <el-radio :label="1">即将到期</el-radio>
          <el-radio :label="2">未及时续签</el-radio>
          <el-radio :label="3">丢失合同</el-radio>
          <el-radio :label="4">已续签</el-radio>
          <el-radio :label="5">续签过去的合同</el-radio>
        </el-radio-group>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
          class="table-sortable-reset-header-padding"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contractNumber"
            label="合同编号"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contactPerson"
            label="联系人(联系电话)"
            width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.contactPerson }}({{ scope.row.contactTelephone }})
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="甲方名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contractStatusName"
            label="合同状态"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="startTime"
            label="开始时间"
            width="100"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="endTime"
            label="结束时间"
            width="100"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="right"
            header-align="right"
            prop="contractAmount"
            label="合同金额"
            width="150"
            sortable="custom"
          >
            <template slot-scope="scope">{{
              scope.row.contractAmount | separator
            }}</template>
          </el-table-column>
          <el-table-column
            align="right"
            header-align="right"
            show-overflow-tooltip
            prop="cashBackAmount"
            label="回款金额"
            width="150"
            sortable="custom"
          >
            <template slot-scope="scope">{{
              scope.row.cashBackAmount | separator
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="payStatusName"
            label="结算状态"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contractSourceName"
            label="合同来源"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contractorName"
            label="签约人"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="attachmentName"
            label="附件"
            width="150"
          ></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="202px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['HTCK']"
                @click="handleDetail(scope.row)"
                >查看</el-button
              >
              <div class="btn-divide" v-if="hasRole['HTCK']"></div>
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['HTBJ']"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <div class="btn-divide" v-if="hasRole['HTBJ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['HTSC']"
                type="text"
                @click="deleteContract(scope.row)"
                >删除</el-button
              >
              <div class="btn-divide" v-if="hasRole['HTSC']"></div>
              <el-dropdown
                class="more-dropdown"
                size="mini"
                trigger="hover"
                @command="(e) => handlerTableDropDown(e, scope.row)"
              >
                <el-button type="text" size="mini">更多</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="over" v-if="hasRole['HTJS']"
                    >合同结束</el-dropdown-item
                  >
                  <el-dropdown-item command="download" v-if="hasRole['HTXZFJ']"
                    >下载附件</el-dropdown-item
                  >
                  <el-dropdown-item command="loss" v-if="hasRole['HTYQDS']"
                    >延期丢失</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <import-dialog
      @cancel="showImport = false"
      @uploadFinish="uploadFinish"
      v-if="showImport"
      :importFun="importFun"
      :downFun="downFun"
    />
    <records v-if="showRecord" @cancel="showRecord = false"></records>
    <ExtensionContract
      v-if="showExtensionContract"
      :extensionTime="extensionTime"
      :contractId="contractId"
      @cancel="showExtensionContract = false"
      @confirm="extensionContractConfirm"
    />
    <FinishContract
      v-if="showFinishContract"
      :endTime="endTime"
      :contractId="contractId"
      @cancel="showFinishContract = false"
      @confirm="finishContractConfirm"
    />
  </div>
</template>

<script>
import {
  exportContract,
  getPageList,
  exportLiftTemplate,
  importContract,
  deleteContract,
  downloadAppendFile,
} from "@/api/ContractManagement";
import { mapState } from "vuex";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import ImportDialog from "@/components/ImportDialog/ImportDialog";
import Records from "./components/Records";
import ExtensionContract from "./components/ExtensionContract";
import FinishContract from "./components/FinishContract";
export default {
  name: "ContractManagement",
  components: {
    ImportDialog,
    Records,
    FinishContract,
    ExtensionContract,
  },
  data() {
    return {
      contractStatusList: [
        {
          dictionaryCode: 1,
          dictionaryValue: "未开始",
        },
        {
          dictionaryCode: 2,
          dictionaryValue: "进行中",
        },
        {
          dictionaryCode: 3,
          dictionaryValue: "已结束",
        },
      ],
      accountingStatusList: [
        {
          dictionaryCode: 1,
          dictionaryValue: "已结清",
        },
        {
          dictionaryCode: 2,
          dictionaryValue: "未结清",
        },
      ],
      paymentPeriodList: [
        {
          dictionaryCode: 3,
          dictionaryValue: "季度支付",
        },
        {
          dictionaryCode: 6,
          dictionaryValue: "半年支付",
        },
        {
          dictionaryCode: 12,
          dictionaryValue: "年度支付",
        },
        {
          dictionaryCode: -3,
          dictionaryValue: "下季度支付",
        },
      ],
      form: {
        contractNumber: null,
        projectId: null,
        propertyUnitName: null,
        contractTypeCode: null,
        contractSourceCode: null,
        contractor: null,
        contractStatus: null,
        accountingStatus: null,
        residentCode: null,
        paymentPeriod: null,
        paymentModeCode: null,
        serviceModeCode: null,
        secondParty: null,
        startTime: null,
        endTime: null,
        contractCode: 0
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      projectList: [],
      timeObj: null,
      showImport: false,
      importFun: importContract,
      downFun: exportLiftTemplate,
      showRecord: false,
      extensionTime: "",
      endTime: "",
      showExtensionContract: false,
      showFinishContract: false,
      contractId: "",
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
    ...mapState("common/dictionary", [
      "htlxDicts",
      "htlyDicts",
      "sfzcDicts",
      "zffsDicts",
      "fwfsDicts",
    ]),
  },
  created() {
    this.getListData();
  },
  methods: {
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      const params = await this.getParams();
      const res = await getPageList(params);
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.timeObj = []
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      this.$router.push({
        name: "ContractEdit",
        query: {
          id: row.contractId,
          canEdit: true,
        },
      });
    },
    handleDetail(row) {
      this.$router.push({
        name: "ContractDetail",
        query: {
          id: row.contractId,
          canEdit: false,
        },
      });
    },
    async exportContract() {
      const params = await this.getParams();
      exportContract(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    deleteContractMore(row) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.contractId);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteContract({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteContract(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteContract({ idList: [row.contractId] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handlerTableDropDown(e, row) {
      this.contractId = row.contractId;

      if (e == "download") {
        downloadAppendFile();
        return;
      }
      if (e == "over") {
        this.showFinishContract = true;
        this.endTime = row.endTime;
        return;
      }
      if (e == "loss") {
        this.showExtensionContract = true;
        this.extensionTime = row.extensionTime;
        return;
      }
    },
    activated() {
      const params = this.$route.params;
      // 新增直接刷新
      if (params.refresh == "1") {
        this.handleRefresh();
      }
      // 编辑刷新当前
      if (params.refresh == "2") {
        this.handleSearch();
      }
    },
    jumpAdd() {
      this.$router.push({
        name: "ContractAdd",
        query: {
          canEdit: true,
        },
      });
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    chooseTime(time) {
      if (time && time.length) {
        this.form.startTime = time[0];
        this.form.endTime = time[1];
      } else {
        this.form.startTime = "";
        this.form.endTime = "";
      }
      this.handleSearchListData();
    },
    handleInput() {
      this.showImport = true;
    },
    uploadFinish() {
      this.showImport = false;
      this.handleSearchListData();
    },
    importRecords() {
      this.showRecord = true;
    },
    extensionContractConfirm() {
      this.showExtensionContract = false;
      this.getListData();
    },
    finishContractConfirm() {
      this.showFinishContract = false;
      this.getListData();
    },
    	// 列表排序
		handleSortChange({column, prop, order}) {
		  if (order === 'ascending') {
		    this.form.sortOrder = 'asc';
				this.form.sortField = prop
		  } else if (order === 'descending') {
		    this.form.sortOrder = 'desc';
				this.form.sortField = prop
		  } else {
		    this.form.sortField = '';
		    this.form.sortOrder = '';
		  }
		  this.getListData();
		},
  },
};
</script>

<style lang="scss">
.contractManagement {
  .el-radio-group {
    margin-bottom: 0 !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ContractManagement/ContractManagement.vue